export default "__VITE_ASSET__6b48ea27__"